"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenserAllowanceDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const inputs_1 = require("../../../../../../../inputs");
const DispenserAllowanceDialog = () => {
    const [showAlert, setShowAlert] = (0, react_1.useState)(false);
    const handleContractChange = (form) => (_event, option) => {
        setShowAlert(option?.title === "USDT");
        form.setValue("contractId", option?.id ?? 0, { shouldDirty: true });
        form.setValue("contract.address", option?.address ?? "0x");
        form.setValue("contract.contractType", option?.contractType ?? "0x");
        form.setValue("contract.decimals", option?.decimals ?? 0);
    };
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [3, 1], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "tokenType", options: types_1.TokenType, disabledOptions: [types_1.TokenType.NATIVE] }), (0, jsx_runtime_1.jsx)(inputs_1.CommonContractInput, { name: "contractId", onChange: handleContractChange, autoselect: true, withTokenType: true }), (0, jsx_runtime_1.jsx)(inputs_1.AmountInput, {}), showAlert && ((0, jsx_runtime_1.jsx)(ui_kit_1.Alert, { severity: "warning", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "messages.allowanceUSDTWarning" }) }))] }));
};
exports.DispenserAllowanceDialog = DispenserAllowanceDialog;
//# sourceMappingURL=index.js.map